/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

import {Component, ViewEncapsulation} from '@angular/core';

/**
 * Component used to load structural styles for focus indicators.
 * @docs-private
 */
@Component({
  selector: 'structural-styles',
  styleUrl: 'structural-styles.css',
  encapsulation: ViewEncapsulation.None,
  template: '',
})
export class _StructuralStylesLoader {}
